import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCompassPointerSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCompassPointerSquare"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM7.37988 16.4678L12 15.3301L16.6201 16.4678L12 6.91992L7.37988 16.4678Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCompassPointerSquare;
